import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=41888517&"
import script from "./NotificationModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports